export default (theme) => ({
    '& .ag-grid-viewport .ag-row .ag-grid-scrolling-cells .ag-cell-inline-editing': {
        borderColor: theme.colors.actionMajor[500],
        borderWidth: '2px',
        width: '100%',
        height: '100%',
        padding: '0',
    },
    '& .ag-grid-viewport .ag-row .ag-grid-scrolling-cells .ag-cell-inline-editing .ag-cell-edit-wrapper':
        {
            width: '100%',
            height: '100%',
        },
    '& .ag-grid-viewport .ag-row .ag-grid-scrolling-cells .ag-cell-inline-editing .ag-cell-edit-wrapper .ag-cell-editor':
        {
            width: '100%',
            height: '100%',
        },
    '& .ag-grid-viewport .ag-row .ag-grid-scrolling-cells .ag-cell-inline-editing .ag-cell-edit-wrapper .ag-cell-editor .ag-input-wrapper':
        {
            width: '100%',
            height: '100%',
        },
    '& .ag-grid-viewport .ag-row .ag-grid-scrolling-cells .ag-cell-inline-editing .ag-cell-edit-wrapper .ag-cell-editor .ag-input-wrapper input':
        {
            width: '100%',
            height: '100%',
            border: 'none',
            padding: '0 20px',
        },
    '& .ag-header': {
        borderBottom: 'none',
    },
    '& .ag-header .ag-grid-pinned-left-cells, & .ag-header .ag-grid-pinned-right-cells': {
        borderBottom: 'none',
        boxSizing: 'border-box',
    },
    '& .ag-advanced-filter-header': {
        borderBottom: 'none',
    },
});
